import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { map, switchMap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import * as AuthActions from './auth.actions';
import { signOut, signOutSuccess, signOutFailure } from './auth.actions';
import { toSerializableUser } from './auth.models';

@Injectable()
export class AuthEffects {
  constructor(
    private actions$: Actions,
    private afAuth: AngularFireAuth,
    private router: Router
  ) {}

  // Listen to Firebase auth state changes
  authState$ = createEffect(() =>
    this.afAuth.authState.pipe(
      map((user) => AuthActions.setCurrentUser({ user: toSerializableUser(user) }))
    )
  );

  // Handle sign out
  signOut$ = createEffect(() =>
    this.actions$.pipe(
      ofType(signOut),
      switchMap(() =>
        this.afAuth.signOut().then(
          () => {
            this.router.navigate(['/auth/sign-in']);
            return signOutSuccess();
          },
          (error) => signOutFailure({ error: error.message })
        )
      ),
      catchError((error) => of(signOutFailure({ error: error.message })))
    )
  );
}
